import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const slug = "coopmonthlyreport";

const MonthlyReportServices = {
  // Define your API functions here

  create: async (data) => {
    const response = await apiService.post(`/${slug}/createreport`, data);
    return response.data;
  },
  submit: async ({ id, data }) => {
    const response = await apiService.patch(
      `/${slug}/submitreport/${id}`,
      data
    );
    return response.data;
  },
  draft: async ({ id, data }) => {
    const response = await apiService.put(`/${slug}/saveasdraft/${id}`, data);
    return response.data;
  },
  // submit: async ({ reportId, remarks }) => {
  //   const response = await apiService.patch(
  //     `/${slug}/submitreport/${reportId}?remarks=${remarks}`
  //   );
  //   return response.data;
  // },
  resubmit: async ({ reportId, remarks, data }) => {
    const response = await apiService.patch(
      `/${slug}/resubmitreport/${reportId}?remarks=${remarks}`,
      data
    );
    return response.data;
  },
  getList: async ({
    submissionNo,
    startDate,
    endDate,
    status,
    cooperativeId,
    coopEmail,
    pageNumber,
    pageSize,
  }) => {
    const response = await apiService.get(
      `/${slug}/getreportlist?SubmissionNo=${submissionNo}&StartDate=${startDate}&EndDate=${endDate}&Status=${status}&CooperativeId=${cooperativeId}&CoopEmail=${coopEmail}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return response.data;
  },

  getDetail: async ({ reportId }) => {
    const response = await apiService.get(`/${slug}/getdetail/${reportId}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/delete/${id}`);
    return response.data;
  },

  getReportListById: async (id) => {
    const response = await apiService.get(`/${slug}/getdetail/${id}`);
    return response.data;
  },
};

export default MonthlyReportServices;
